// InlineText.tsx — Auto-sizing inline input with dashed border. Ported from web/src/components/ui.
import React from 'react';

export interface InlineTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
    minWidth?: number;
    className?: string;
}

const InlineText = ({
    value,
    minWidth = 1,
    className,
    style,
    placeholder,
    ...props
}: InlineTextProps) => {
    let textToMeasure = value;
    if (!value && placeholder) {
        textToMeasure = placeholder;
    }
    const length = typeof textToMeasure === 'string' ? textToMeasure.length : 0;
    const effectiveWidth = Math.max(length, minWidth);

    return (
        <input
            type="text"
            value={value}
            placeholder={placeholder}
            style={{
                background: 'transparent',
                border: '1px dashed var(--color-border-default)',
                color: 'var(--color-text-primary)',
                fontFamily: 'var(--font-mono)',
                padding: '0 0.2em',
                display: 'inline-block',
                width: `calc(${effectiveWidth}ch + 0.5em)`,
                transition: 'width 0.1s ease-out',
                borderRadius: 'var(--radius-sm)',
                ...style,
            }}
            className={className}
            {...props}
        />
    );
};

export default InlineText;
export { InlineText };
